/****************************************************
 * Module Name:  pendingLotReceive.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Constants from "../../utility/constants";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Tooltip, Typography, } from "@mui/material";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import LotIntimationProxy from "../../utility/proxy/manager/manufacturingProxy/lotIntimationProxy";
import { LoadingButton } from "@mui/lab";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class PendingLotReceive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lotIntimations: [],
      showAddLotIntimationModal: false,
      showAddLotCreationModal: false,
      lotIntimationId: "",
      lotIntimationname: "",

      editOperation: false,
      sourceData: {},
      vendorId: "",
      errorSnackbar: false,
      errorMessage: "",
      snackbarVariant: "",
      loadingButton: false,
      newVendor: "",
      accesDenied: false,
      showLotIntimationLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.MANUFACTURING_REPORT_PENDINGLOTRECEIVE
      ),
    };
    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("MANUFACTURING_REPORT_PENDINGLOTRECEIVE");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchLotIntimationData(false);
    }
  }

  fetchLotIntimationData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showLotIntimationLoadSpinner: true });
    let data =
      this.state.newVendor === "" || this.state.newVendor.value === "*"
        ? []
        : Utility.GetValueArrayWithStarReplace(this.state.newVendor, []);
    LotIntimationProxy.LotIntimationPendingReceive(data, (responseData) => {
      if (responseData) {
        this.setState({
          lotIntimations: responseData,
          showLotIntimationLoadSpinner: false,
        })
      } else {
        this.setState({
          errorSnackbar: true,
          errorMessage: Constants.APiFailErrorMessage,
          snackbarVariant: "error",
          showLotIntimationLoadSpinner: false,
        });
      }
    }
    );
  };

  columns = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      minWidth: 50,
      type: 'number',
      flex: 0.5,
    },
    {
      field: "vendorid",
      headerName: "VENDOR ID",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      renderCell: renderCellExpand,
      disableExport: true,
    },
    {
      field: "weight",
      headerName: "WEIGHT",
      headerAlign: "center",
      align: "center",
      minWidth: 50,
      type: 'number',
      flex: 0.5,
      renderCell: renderCellExpand,
    },
    {
      field: "date",
      headerName: "DATE",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "expectedreceive",
      headerName: "EXPECTED RECEIVE",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
  ];

  handleValidation = (lotIntimationData) => {
    //TODO do validation if needed here
    return true;
  };

  render() {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.lotIntimations;
    const columns = this.columns

    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{this.state.errorMessage}</Box>}
          variant={this.state.snackbarVariant}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title={
            this.state.snackbarVariant === "success" ? "Success" : "Failed"
          }
        />
        <Box px={1}>
          <Box sx={{ display: "flex", gap: "15px", mb: 3 }}>
            <Typography sx={{ width: "70px", alignSelf: "center" }}>
              Vendor
            </Typography>

            <Box minWidth={"350px"}>
              <Select menuPlacement="auto"
                blurInputOnSelect={false}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                value={this.state.newVendor}
                isSearchable={true}
                name="Vendor"
                isMulti
                closeMenuOnSelect={false}
                menuPortalTarget={document.body}
                styles={Constants.Styles}
                options={this.state.vendorOptions}
                onChange={(selectedOption) =>
                  this.setState({
                    newVendor: selectedOption,
                  })
                }
              />
            </Box>
            <Box>
              <LoadingButton
                loading={this.state.showLotIntimationLoadSpinner}
                loadingPosition="start"
                disabled={this.state.vendorOptions.length === 0}
                variant="contained"
                onClick={() => this.fetchLotIntimationData(true)}
                startIcon={<SearchOutlinedIcon size="large" />}
              >
                Search
              </LoadingButton>
            </Box>
          </Box>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "80vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "5px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: GridToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              loading={this.state.showLotIntimationLoadSpinner}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    locationid: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
            <Box style={{ position: "absolute", top: 5, right: "270px" }}>
              {this.state.showLotIntimationLoadSpinner ? (
                <CircularProgress size="25px" sx={{ lineHeight: -2 }} />
              ) : (
                <Tooltip title="Reload List">
                  <RefreshOutlinedIcon
                    color="primary"
                    fontSize="medium"
                    onClick={() => this.fetchLotIntimationData(true)}
                    sx={{ cursor: "pointer" }}
                  />
                </Tooltip>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default PendingLotReceive;
